export const isThemedSvg = (svg: string) =>
  /light-dark\(|prefers-color-scheme/.test(svg);

export function svgForColorScheme(
  svg: string,
  scheme: "light" | "dark"
): string {
  // Safari needs the SVG’s own scheme pinned instead of inherited from its image.
  return svg
    .replace(
      /<svg\b[^>]*>/,
      `$&<style>:root{color-scheme:${scheme}!important}</style>`
    )
    .replace(/\(prefers-color-scheme:\s*(light|dark)\)/g, (_, preference) =>
      preference === scheme ? "all" : "not all"
    );
}

export function themedSvgDataUrls(
  svg: string
): { light: string; dark: string } | null {
  if (!isThemedSvg(svg)) return null;
  const dataUrl = (scheme: "light" | "dark") =>
    `data:image/svg+xml,${encodeURIComponent(svgForColorScheme(svg, scheme))}`;
  return { light: dataUrl("light"), dark: dataUrl("dark") };
}
